import {useDebugValue, useEffect} from 'react';

import {getObjectValues} from '../../../utils';

function useDetailsModalActions(data) {
    const {
        detailsModalEvents: {
            onSettingsChange
        },
        initialDetailsModalSettings,
        changeDetailsModalSettings
    } = data;

    function setSettings(nextSettings) {
        changeDetailsModalSettings(nextSettings);

        onSettingsChange(nextSettings);
    }

    function setSettingsInitial() {
        setSettings(initialDetailsModalSettings);
    }

    function setIsOpen(isOpen) {
        setSettings({
            isOpen
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(setSettingsInitial, [...getObjectValues(initialDetailsModalSettings)]);

    const result = {
        setIsOpen
    };

    useDebugValue(result);

    return result;
}

export {useDetailsModalActions};
